import { Layout } from "components/Layout"
import { Header } from "components/Header"
import { Footer } from "components/Footer"
import { RecipeFooter } from "features/Recipes/components/RecipeFooter"
import { useTranslation } from "hooks/useTranslation"
import { TreatsRoot } from "./Treats.styles"
import { Hero } from "./components/Hero"
import { Porktein } from "./components/Porktein"
import { Bison } from "./components/Bison"
import { AllProducts } from "./components/AllProducts"
import { StartrMixin } from "./components/StartrMixin"
import { Reviews } from "features/Recipes/components/Reviews"
import { ProductPageReviews } from 'fixtures/review'
export const Treats = () => {
    const header = <Header />
    const { t } = useTranslation()

    const { anu, valerie, katie } = ProductPageReviews

    return (
        <TreatsRoot>
            <Layout hideCTA header={header}>
                <Hero /> 
                <Porktein />
                <Bison />
                <AllProducts />
                <StartrMixin />
                <Reviews icon={false} background='tertiary-200' reviews={[anu, valerie, katie]}/>
              <RecipeFooter ctaLink='/meal-plan' cta={t('products:footer.cta1')} header={t('products:footer.title')}  />
              <Footer />
            </Layout>
        </TreatsRoot>
    )
}